import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

import React from 'react'
import { AiFillDelete } from 'react-icons/ai'
import { BiEdit } from 'react-icons/bi'
// import { GrCircleInformation } from 'react-icons/gi'
import { HiOutlineInformationCircle } from 'react-icons/hi'

export default function ActionIcon2({ dialog1, dialog2, dialog3 }) {
  return (
    <Box display="flex" justifyContent="center">
      <Tooltip title="Edit">
        <IconButton onClick={dialog1}>
          <BiEdit style={{ color: '#383CC1' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete" style={{ marginLeft: '5px' }}>
        <IconButton onClick={dialog2} style={{ color: 'red', paddingLeft: '10px' }}>
          <AiFillDelete />
        </IconButton>
      </Tooltip>
      <Tooltip title="Detail" style={{ marginLeft: '5px' }}>
        <IconButton color="inherit" onClick={dialog3} style={{ paddingLeft: '10px' }}>
          <HiOutlineInformationCircle />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
